/**
 * Store links for the GoTu mobile app.
 *
 * `com.tempmeeapp` is the production `applicationId` declared in
 * mobile-app/android/app/build.gradle.
 */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/tempmee/id1437086894';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.tempmeeapp';

// Match Android rather than Apple: every Android browser UA (Chrome, Firefox,
// Samsung Internet, WebView) carries the literal `Android`, whereas iOS spreads
// across iPhone/iPad/iPod and iPadOS 13+ Safari reports itself as `Macintosh`.
// Testing the reliable half and defaulting to the App Store preserves today's
// behaviour for every UA we don't recognise, so this can only ever fix Android
// users — it cannot break the iOS users who already work.
export const getMobileStoreUrl = (userAgent: string = navigator.userAgent): string =>
  /android/i.test(userAgent) ? PLAY_STORE_URL : APP_STORE_URL;
